import React from 'react';
import styled from 'styled-components';
import {Spinner as OriginalSpinner, SpinnerSize} from '@fluentui/react';

const Wrapper = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

type Props = {
  size?: SpinnerSize;
};

export function Spinner({size = SpinnerSize.large}: Props): JSX.Element | null {
  return (
    <Wrapper>
      <OriginalSpinner size={size} />
    </Wrapper>
  );
}
